let extendedUrl = "/service";
// let resumableuploadUrl = "/resumableupload"
import NoImg from "../src/assets/logo.jpg"
import folderImg from "../src/assets/folder.png"
import favIcon from "../src/assets/DAMfavicon.png"
import damLogo from "../src/assets/dam_logo.png"
import uploadGif from "../src/assets/uploadinggif.gif"
import loadingGif from "../src/assets/loadinggif.gif"
import projectBackground from "../src/assets/project_banner_1.jpg"
import markForDeleteIcon from "../src/assets/mark_for_delete_asset.png"
import catalogTreeStructureImg from "../src/assets/Catalog-tree.png"
import noDataFound from "../src/assets/noDataFound.png"
import fusionLogoWithText from "../src/assets/Fusion_light.png"
import notificationAudio from "../src/assets/5.mp3"
import secondaryNotificationAudio from "../src/assets/4.mp3"
import facebookLogo from "../src/assets/facebook.png"
import twitterLogo from "../src/assets/twitter.png"
import youtubeLogo1 from "../src/assets/youIcon.png"
import youtubeLogo from "../src/assets/youtube_social_icon_red.png"
import youtubeThumb from "../src/assets/youtube.png"
import newImage from "../src/assets/newImg.png"
import altoLogo from "../src/assets/alto_logo.png"
import downloadingGif from "../src/assets/downloading.gif"
import editProCutIcon from "../src/assets/Mediamodifier-Design-Template.png"
import loadingImage from "../src/assets/LoadingImage.png"
import AIImage from "../src/assets/AI_image.png"
import MetadataSmartExtractImage from "../src/assets/aiActionsImage.png"

export const NotifierConstants = {
    labelCreated: "LABEL_CREATED",
    labelUpdated: "LABEL_UPDATED",
    labelDeleted: "LABEL_DELETED",
    languageUpdated: "LANGUAGE_UPDATED",
    srtFileCreatedNotification : "GENERATE_SRT_COMPLETED",
    transcriptCreatedNotification : "TRANSCRIPT_CREATED",
    transcriptUpdatedNotification : "TRANSCRIPT_UPDATED",
    ocrCreatedNotification : "OCR_CREATED",
    ocrUpdatedNotification: "OCR_UPDATED",
    obdCreatedNotification: "OBD_CREATED",
    obdUpdatedNotification: "OBD_UPDATED",
    obdFrameExtractedNotification: "OBD_FRAME_EXTRACTED",
    obdFrameCreatedNotification: "OBD_FRAME_CREATED",
    personalityCreateNotification: "PERSONALITY_CREATED",
    personalityUpdateNotification: "PERSONALITY_UPDATED",
    personalityDeleteNotification: "PERSONALITY_DELETED",
    faceDetectionCreateNotification: "FACE_DETECTION_CREATED",
    faceDetectionUpdateNotification: "FACE_DETECTION_UPDATED",
    faceFrameCreateNotification: "FD_FRAME_CREATED",
    faceFrameExtractedNotification: "FD_FRAME_EXTRACTED",
    objectRemovedNotification:"OBJECT_REMOVED_FROM_OBD",
    removeFromPersonalityNotification:"REMOVED_FROM_PERSONALITY",
    addedToPersonalityDataSetNotification : "ADDED_TO_PERSONALITY_DATASET",
    addedToPersonalitiesDataSetCompletedNotification: "ADD_TO_PERSONALITY_DATASET_COMPLETED",
    removeFromDataSetNotification:"REMOVED_FROM_DATASET",
    trainDataSetCompletedNotification:"TRAIN_DATA_SET_COMPLETED",
    metadataReqCommentCreated: "METADATA_REQUEST_COMMENT_CREATED",
    metadataReqCommentUpdated: "METADATA_REQUEST_COMMENT_UPDATED",
    metadataReqCommentDeleted: "METADATA_REQUEST_COMMENT_DELETED",
    metadataRequestCreated: "METADATA_REQUEST_CREATED",
    metadataRequestUpdated: "METADATA_REQUEST_UPDATED",
    searchAliasCreatedNotification:"SEARCH_ALIAS_CREATED",
    searchAliasUpdatedNotification:"SEARCH_ALIAS_UPDATED",
    searchAliasDelteddNotification:"SEARCH_ALIAS_DELETED",
    fieldCreatedNotification: "CUSTOM_METADATA_CREATED",
    fieldModifiedNotification: "CUSTOM_METADATA_UPDATED",
    fieldRemovedNotification: "CUSTOM_METADATA_DELETED",
    screenModifiedNotification: "SCREEN_UPDATED",
    screenProfileCreatedNotification: "METADATA_PROFILE_CREATED",
    screenProfileModifiedNotification: "METADATA_PROFILE_UPDATED",
    screenProfileRemovedNotification: "METADATA_PROFILE_DELETED",
    dynamicQueryBuildDeletedNotification:"DYNAMIC_REPORT_DELETED",
    dynamicQueryBuildCretedNotification:"DYNAMIC_REPORT_CREATED",
    dynamicQueryBuildModifiedNotification:"DYNAMIC_REPORT_MODIFIED",
    userGroupCreatedNotification: "USER_GROUP_CREATED",
    userGroupModifiedNotification: "USER_GROUP_UPDATED",
    userGroupRemovedNotification: "USER_GROUP_DELETED",
    fileCreatedNotification: "FILE_CREATED",
    fileModifiedNotification: "FILE_UPDATED",
    fileRemovedNotification: "FILE_DELETED",
    fileOutdatedNotification: "FILE_OUTDATED",
    catalogCreatedNotification: "CATEGORY_CREATED",
    catalogModifiedNotification: "CATEGORY_UPDATED",
    catalogRemovedCreatedNotification: "CATEGORY_DELETED",
    catalogCountSizeUpdatedNotification: "CATALOG_COUNT_SIZE_UPDATED",
    assetCreatedNotification: "ASSET_CREATED",
    assetModifiedNotification: "ASSET_UPDATED",
    assetRemovedCreatedNotification: "ASSET_DELETED",
    assetOutdatedNotification:'ASSET_OUTDATED',
    AssetLinkTypeUpdated:'ASSET_LINK_TYPE_UPDATED',
    AssetLinkTypeCreated: 'ASSET_LINK_TYPE_CREATED',
    AssetLinkTypeDeleted: 'ASSET_LINK_TYPE_DELETED',
    AssetLinksUpdated: 'ASSET_LINKS_UPDATED',
    customProxyGeneratedNotification: 'CUSTOM_PROXY_GENERATED',
    favoriteCreatedNotification: "FAVORITE_CREATED",
    favoriteModifiedNotification: "FAVORITE_UPDATED",
    favoriteRemovedNotification: "FAVORITE_DELETED",
    tagCreatedNotification: "TAG_CREATED",
    tagModifiedNotification: "TAG_UPDATED",
    tagRemovedNotification: "TAG_DELETED",
    userCreatedNotification: "USER_CREATED",
    userModifiedNotification: "USER_UPDATED",
    userRemovedNotification: "USER_DELETED",
    binCreatedNotification: "BIN_CREATED",
    binModifiedNotification: "BIN_UPDATED",
    binRemovedNotification: "BIN_DELETED",
    binAccessibilityNotification: "BIN_ACCESSIBILITY_UPDATED",
    userLoggedInNotification: "USER_LOGGED_IN",
    userLoggedOutNotification: "USER_LOGGED_OUT",
    licenseUpdatedNotification: "LICENSE_UPDATED",
    retreiveSettingsNotification: "RETRIEVAL_SETTINGS_UPDATED",
    uploadSettingsNotification : "UPLOAD_SETTINGS_UPDATED",
    userUpdatedNotification : "USER_UPDATED",
    plugininstalledNotification : "PLUGIN_INSTALLED",
    pluginupgradedNotification : "PLUGIN_UPGRADED",
    pluginUninstalledNotification : "PLUGIN_UNINSTALLED",
    plugininstalledNotificationinspluginStore : "PLUGIN_INSTALLED",
    pluginUninstalledNotificationpluginStore : "PLUGIN_UNINSTALLED",
    proxyUpdatedNotification: 'PROXY_UPDATED',
    //PAM-------------------
    pamUserCreatedNotification: 'PAM_USER_CREATED',
    pamUserDeletedNotification: 'PAM_USER_DELETED',
    //-----------------------------
    fileArchivedNotification : "FILE_ARCHIVED",

    //Tasks
    taskCreationNotification: "TASK_CREATED",
    taskUpdateNotification: "TASK_UPDATED",
    taskDeleteNotification: "TASK_DELETED",

    //Hype posts
    hypePostsUpdate:"HYPE_POSTS_UPDATE",

    //Messages---------------------------------------
    messageCreatedNotification: "Message_Created",
    messageModifiedNotification: "Message_Modified",
    mentionedYouInMessageNotification: "Mentioned_You",
    replyCountModifiedNotification:"Reply_count_modified",
    channelCreatedNotification:"Channel_Created",
    channelModifiedNotification:"Channel_Modified",
    channelDeletedNotification:"Channel_Deleted",
    //-----------------------------------------------
    
    //media share
    mediaShareNotification: "SHARED_FILE",

    //User notification--------------------------
    userNotificationCreated: "NOTIFICATION_CREATED",

    //web Hook --------------------------------
    webHookCreateNotification: "HOOKSCRIPT_CREATED",
    webHookUpdateNotification: "HOOKSCRIPT_UPDATED",
    webHookDeleteNotification: "HOOKSCRIPT_DELETED",

    //workflow
    workflowTaskRouteCreated: "WORKFLOW_TASKROUTE_CREATED",
    workflowTaskRouteUpdated: "WORKFLOW_TASKROUTE_UPDATED",

    //scheduler
    schedulerCreateNotification: "SCHEDULE_TASK_CREATED",
    schedulerUpdateNotification: "SCHEDULE_TASK_UPDATED",
    schedulerDeleteNotification: "SCHEDULE_TASK_DELETED",

    //Global settings
    globalSettingsUpdatedNotification: "GLOBAL_SETTINGS_UPDATED",
    searchSettingsUpdatedNotification: "SEARCH_SETTINGS_UPDATED",
    
    //Remote edit
    remoteEditProjectModified: "RemoteEditProjectModified",
    remoteEditProjectCreated:"RemoteEditProjectCreated",
    
    //Resource Usage
    remoteResouceUsage:"REMOTE_RESOURCE_USAGE",

    //Upload
    uploadSettingsUpdated:'UPLOAD_SETTINGS_UPDATED',

    //Version
    mediaVersionSettingsUpdated:'MEDIA_VERSION_SETTINGS_UPDATED',

    //PAM Status
    PAMStatusCreated:'STATUS_CREATED',
    PAMStatusModified:'STATUS_MODIFIED',
    PAMStatusDeleted:'STATUS_DELETED',

    //PAM Pipeline
    StageTaskCreated:"StageTaskCreated",
    StageCreated:"StageCreated",
    StageTaskDeleted:"StageTaskDeleted",
    StageTaskModified:"StageTaskModified",
    StageModified:"StageModified",
    StageDeleted:"StageDeleted",
    TemplateCreated:"TemplateCreated",
    TemplateModified:"TemplateModified",
    TemplateDeleted:"TemplateDeleted",

    //Media QC
    mediaQCCommentCreated:'MediaQcCommentCreated',
    mediaQcCommentUpdated:'MediaQcCommentUpdated',
    mediaQcCommentDeleted:'MediaQcCommentDeleted',
    mediaQCCreated:'MEDIA_QC_CREATED',
    mediaQCUpdated:'MediaQcUpdated', //MediaQcUpdated

    //Asset Comment
    assetCommentCreated:'CommentCreated',
    assetCommentModified:'CommentModified',

    //Face detection
    faceDetectionConfigUpdated:'AI_Face_Detection_SETTINGS_UPDATED',

    //Subclips settings
    subclipsSettingsUpdated:"SUBCLIP_SETTINGS_UPDATED",

    //Advanced search 
    globalSearchFilterUpdated:"GLOBAL_SEARCH_FILTER_UPDATED",
    userFilterSearchUpdated:"USER_SEARCH_FILTER_UPDATED",
    
    //PEO Projects
    departmentCreated:'DEPARTMENT_CREATED',
    departmentUpdated:'DEPARTMENT_UPDATED',
    departmentDeleted:'DEPARTMENT_DELETED',

    //LDAP
    LDAPUpdatedNotification:'LDAP_SETTINGS_UPDATED'
}

export default {
    defaultTitle:"FUSION",
    startRoute:"/", //this should be changed when dam location in nginx is not /. Value should nginx dam location value
    NotifierIP: window.location.host,
    windowLocationHref: window.location.href,
    // NotifierIP: "192.168.1.4",
    quickAccessPanelType: "QuickAccessPanel",
    OverflowMenuType: "OverflowMenu",
    settingsSideMenuType: "settingsSideMenu",
    reportsSideMenuType: "reportsSideMenu",
    systemSettingsMenu: "systemSettingsMenu",
    propertiesTopNav: "propertiesTopNav",
    importExportMenu: "importExportMenu",
    externalPluginDialog: "externalPluginDialog",
    floatingMenuType: "floatingMenu",
    binsContextMenuType: "BinsContextMenu",
    binsMoreContextMenuType: "BinsMoreContextMenu",
    preferencesSidemenuType: "PreferencesSidemenu",
    dashboardWidgetsType: "DashboardWidget",
    shareTopMenu: "shareTopMenu",
    usersUrl: `${extendedUrl}/users`,
    usersAutoComplitionUrl: `${extendedUrl}/users/auto-complete`,
    userGroupsUrl: `${extendedUrl}/user-groups`,
    auditTrailUrl: `${extendedUrl}/user-logs`,
    sessionUserAuditTrailUrl: `${extendedUrl}/session-user-logs`,
    downloadauditTrailReportUrl: `${extendedUrl}/download/audit-data`,
    sessionauditTrailReportUrl: `${extendedUrl}/download/session-audit-data`,
    downloadMediaPipelineReportUrl:`${extendedUrl}/media-pipeline-data`,
    assetLabelUrl: `${extendedUrl}/asset/label`,
    assetArchiveRequestUrl: `${extendedUrl}/assets/archive-request`,
    assetRetrieveRequestUrl: `${extendedUrl}/assets/retrieve-request`,
    assetTranscoderT1RequestUrl: `${extendedUrl}/assets/delievery-to-target1-request`,
    assetTranscoderT2RequestUrl: `${extendedUrl}/assets/delievery-to-target2-request`,
    categoriesUrl: `${extendedUrl}/assets`,
    assetsIngestUrl: `${extendedUrl}/assets-ingest`,
    photoAlbumUrl: `${extendedUrl}/photo-album`,
    packageUrl : `${extendedUrl}/package`,
    categoriesAutoCompleteUrl: `${extendedUrl}/assets`,
    tagsAutocompleteUrl: `${extendedUrl}/tags/auto-complete`,
    tagsUrl: `${extendedUrl}/tags`,
    tagconfirmationUrl: `${extendedUrl}/tags/tagged-assets/`,
    favoritesUrl: `${extendedUrl}/favorites`,
    languagesUrl: `${extendedUrl}/languages`,
    customMetadataUrl: `${extendedUrl}/custom-metadatas`,
    fieldConfirmationUrl: `${extendedUrl}/custom-metadatas/tagged-assets`,
    screenUrl: `${extendedUrl}/screens`,
    metadataProfileUrl: `${extendedUrl}/metadata-profiles`,
    metadataRequestUrl: `${extendedUrl}/metadata-request`,
    metadataApproverUrl: `${extendedUrl}/metadata-request-to-approve`,
    relaventMetadataProfilesUrl: `${extendedUrl}/metadata-profiles/relevant`,
    transcoderProfilesUrl:`${extendedUrl}/plugin-settings/transcoder/profiles`,
    configuredTranscoderProfilesUrl: `${extendedUrl}/plugin-settings/transcoder/configured-profiles`,
    editproProfilesUrl:`${extendedUrl}/plugin-settings/edit_pro/profiles`,
    objectDetectionPluginConfigUrl:`${extendedUrl}/plugin-settings/ai-obd`,
    faceDetectionPluginConfigUrl : `${extendedUrl}/plugin-settings/ai-face-detection`,
    aiPersonalitiesUrl:`${extendedUrl}/ai/personalities`,
    dataSetPersonalitiesUrl:`${extendedUrl}/personalities`,
    loginUrl: `${extendedUrl}/login`,
    logoutUrl: `${extendedUrl}/logout`,
    binsUrl: `${extendedUrl}/bins`,
    binFoldersUrl: `${extendedUrl}/files-folder`,
    binStatusUrl: `${extendedUrl}/bin-status`,
    binAccessibilityStatusUrl: `${extendedUrl}/bins/protocol_credentials`,
    filesUrl: `${extendedUrl}/files`,
    foldersUrl: `${extendedUrl}/folders`,
    searchKeyworAutoCOmpleteUrl:`${extendedUrl}/search/auto-complete`,
    assetsUrl: `${extendedUrl}/assets`,
    nlpAssetsUrl: `${extendedUrl}/assets/NLP`,
    assetsLinkUrl: `${extendedUrl}/assets/link`,
    linkConfirmationUrl: `${extendedUrl}/assets/linked-asset`,
    assetLinkTypesUrl: `${extendedUrl}/assets-link-types`,
    assetsReportUrl: `${extendedUrl}/assets/reports`,
    outboxUrl: `${extendedUrl}/outbox-export`,
    queryBasedReportsDownloadUrl: `${extendedUrl}/dynamic-report-generator/download`,
    queryBuilderTypesUrl : `${extendedUrl}/dynamic-report-generator/types`,
    queryBuilderUrl : `${extendedUrl}/dynamic-report-generator`,
    queryBuilderQueryParamtersUrl : `${extendedUrl}/search-filters/reports_workspace`,
    columsRequiredInQueryBuilderUrl : `${extendedUrl}/columns-required`,
    singleAssetUrl: `${extendedUrl}/asset`,
    assetCommentsUrl: `${extendedUrl}/assets/comments`,
    assetsMetadataUrl: `${extendedUrl}/assets-metadata`,
    assetVersionUpdateUrl: `${extendedUrl}/assets/update-version`,
    assetsAutoCompleteUrl: `${extendedUrl}/assets/catalog/auto-complete`,
    privileges: `${extendedUrl}/privileges`,
    userSettings: `${extendedUrl}/user-settings`,
    userSpace: `${extendedUrl}/user-space`,
    userBinActions: `${extendedUrl}/user-actions`,
    startUpDataUrl: `${extendedUrl}/startup-data`,
    userCatalogActions: `${extendedUrl}/user-catelog-actions`,
    poolsUrl: `${extendedUrl}/pools`,
    poolDevicesUrl: `${extendedUrl}/pool_devices`,
    settingsUrl: `${extendedUrl}/settings`,
    licensedSystemInfoUrl: `${extendedUrl}/download-system-info`,
    migrationUploadUrl: `${extendedUrl}/migration/upload`,
    licenseUrl:`${extendedUrl}/license`,
    uploadLicensedInfoUrl: `${extendedUrl}/license/upload`,
    pluginRepoUrl: `${extendedUrl}/plugins/store`,
    pluginRepoInstalledUrl: `${extendedUrl}/plugins/installed`,
    pluginsUrl: `${extendedUrl}/plugins`,
    nginxUploadUrl: `/resumableUpload`, 
    jobsUrl: `${extendedUrl}/jobs`,
    customProxyUrl: `${extendedUrl}/custom-proxy`,
    uploadUrl: `${extendedUrl}/upload`,
    sessionInfoUrl: `${extendedUrl}/upload-status`,
    downloadUrl: `${extendedUrl}/download`,
    downloadProxyUrl: `${extendedUrl}/download_proxy`,
    storageReportUrl:`${extendedUrl}/storage-report/bins`,
    systemInfoUrl: `${extendedUrl}/system-info`,
    versionInfoUrl: `${extendedUrl}/dam-version-details`,
    downloadStorageReportUrl:`${extendedUrl}/download/storage-data/bins`,
    downloadDownloadReportUrl:`${extendedUrl}/download/download-data`,
    downloadDownloadSessionReportUrl:`${extendedUrl}/download/session-download-data`,
    downloadIngestReportUrl:`${extendedUrl}/download/ingest-data`,
    downloadIngestSessionReportUrl:`${extendedUrl}/download/session-ingest-data`,
    downloadJobsReportUrl:`${extendedUrl}/download/jobs-data`,
    downloadJobsSessionReportUrl:`${extendedUrl}/download/session-jobs-data`,
    downloadArchiveReportUrl:`${extendedUrl}/download/archive-data`,
    downloadArchiveSessionReportUrl:`${extendedUrl}/download/session-archive-data`,
    downloadRetrieveReportUrl:`${extendedUrl}/download/retrieve-data`,
    downloadRetrieveSessionReportUrl : `${extendedUrl}/download/session-retrieve-data`,
    sessionUseringestReportUrl:`${extendedUrl}/session-ingest-report`,
    ingestReportUrl:`${extendedUrl}/ingest-report`,
    sessionUserJobsReportUrl:`${extendedUrl}/session-jobs-report`,
    JobsReportUrl:`${extendedUrl}/jobs-report`,
    sessionUserDownloadReportUrl:`${extendedUrl}/session-download-report`,
    downloadReportUrl:`${extendedUrl}/download-report`,
    sessionUserArchvieReportUrl:`${extendedUrl}/session-archive-report`,
    archiveReportUrl: `${extendedUrl}/archive-report`,
    sessionUserRetrieveReportUrl:`${extendedUrl}/session-retrieve-report`,
    retrieveReportUrl:`${extendedUrl}/retrieve-report`,
    duplicateReportsUrl: `${extendedUrl}/duplicates`,
    reviewdataurl:`${extendedUrl}/reviews`,
    reviewParentCommentGetUrl:`${extendedUrl}/review-parent-comments`,
    remoteEditProjectsUrl:`${extendedUrl}/remote-edit-projects`,
    searchFiltersUrl: `${extendedUrl}/search-filters`,
    searchFilterConfigURL: `${extendedUrl}/configured-search-filters`,
    searchUrl: `${extendedUrl}/search`,
    tasksUrl: `${extendedUrl}/tasks`,
    commentRepliesdataurl:`${extendedUrl}/review-comment-threads`,
    taskCommentRepliesdataurl:`${extendedUrl}/pam-comment-threads`,
    ticketCommentRepliesdataurl:`${extendedUrl}/ticket-comment-threads`,
    indReviewdataurl :`${extendedUrl}/reviews`,
    kanbanBoardUrl:`${extendedUrl}/kanban-tasks`,
    tasksIssuesUrl:`${extendedUrl}/tasks`,
    ticketUrl : `${extendedUrl}/tickets`,
    parentCommentGetUrl:`${extendedUrl}/pam-parent-comments`,
    ticketParentCommentGetUrl:`${extendedUrl}/ticket-parent-comments`,
    projectsUrl:`${extendedUrl}/projects`,
    ticketProjectsUrl:`${extendedUrl}/ticket-projects`,
    projectsUsersUrl: `${extendedUrl}/pam-users`,
    cloneTicketUrl: `${extendedUrl}/clone`,
    linkTypeUrl: `${extendedUrl}/link-types`,
    taskHistoryUrl:`${extendedUrl}/history`,
    editProPlaceholderUrl : `${extendedUrl}/placeholder`,
    editProProjectsUrl : `${extendedUrl}/edit-pro-projects`,
    editProProjectUndoURL : `${extendedUrl}/edit-pro-projects/history/undo`,
    editProProjectRedoURL:  `${extendedUrl}/edit-pro-projects/history/redo`,
    clearProjectHistoryURL: `${extendedUrl}/edit-pro-projects/history`,
    editProPluginCOnfigUrl: `${extendedUrl}/plugin-settings/edit-pro`,
    proxyBinUploadUrl:`${extendedUrl}/upload/proxy-request`,
    faceRecogServiceURL: `${extendedUrl}/ai/face-detection/service`,
    faceDetectionUrl:`${extendedUrl}/ai/face-detection`,
    objectRecogServiceURL: `${extendedUrl}/ai/obd/service`,
    objectDetectionUrl:`${extendedUrl}/ai/obd`,
    messagesUrl:`${extendedUrl}/messages`,
    messageUsersUrl: `${extendedUrl}/message-users`,
    messageChannels: `${extendedUrl}/message-channels`,
    sharedAssests: `${extendedUrl}/share/dam`,
    remoteSystemStatsIndData: `${extendedUrl}/remote-system-stats`,
    // allResourceusageByGroupUrl: `${extendedUrl}/resourceusage/group/remote-system-stats`,
    allResourceusageByGroupUrl: `${extendedUrl}/remote_system_stats/group`,
    remoteSystemStatsClientListData : `${extendedUrl}/remote-system-stats/clients-list`,
    hypePosts: `${extendedUrl}/hype/posts`,
    newUpdates: `${extendedUrl}/new-updates`,
    webHookUrl: `${extendedUrl}/hook-scripts`,
    triggersUrl: `${extendedUrl}/workflow-triggers`,
    schedulerTaskUrl :  `${extendedUrl}/schedule-tasks`,
    schedulerAdvancedVerifyUrl :  `${extendedUrl}/scheduler/advanced/cron-line-parser`, 
    schedulerClassServiceUrl :  `${extendedUrl}/schedule_services`, 
    loggedInUserUrl: `${extendedUrl}/loggedin-users`,
    extendedUrl: `${extendedUrl}`,
    // uploadFileUrl: `${extendedUrl}/upload`,
    userNotificationUrl: `${extendedUrl}/user-notifications`,
    userNotificationSettingUrl: `${extendedUrl}/user-notif-settings`,
    trendingTagsUrl: `${extendedUrl}/hype/tags/auto-complete`,
    hypeSocialMediaConfigUrl : `${extendedUrl}/plugin-settings/hype`,
    dashboardWidgetsUrl: `${extendedUrl}/dashboard`,
    elasticReindexStatus: `${extendedUrl}/elastic-reindex-status`,
    reviewUsers: `${extendedUrl}/review-users`,
    clientAccessToken: `${extendedUrl}/client-access-tokens`,
    clientAccessTokenStatus: `${extendedUrl}/client-access-token-status`,
    catalogPoolMapper: `${extendedUrl}/catalogs-pools-mapper`,
    catalogAssetsCount: `${extendedUrl}/catalog/assets-count`,
    searchAliasUrl : `${extendedUrl}/search-alias`,
    ocrExtractUrl: `/ai/job`,
    ocrFileInfoUrl:`${extendedUrl}/ai/ocr`,
    subclipTransctiptUrl: `${extendedUrl}/ai/transcript/subclip`,
    audioVideoTransctiptUrl: `${extendedUrl}/ai/transcript`,
    transcriptServiceUrl: `${extendedUrl}/ai/transcript/service`,
    transcriptSupportedLanguageUrl: `${extendedUrl}/transcript/languages`,
    ocrServiceUrl: `${extendedUrl}/ai/ocr/service`,
    ocrSupportedLanguageUrl: `${extendedUrl}/ocr/languages`,
    versionPlaceholder: `${extendedUrl}/version-placeholder`,
    versionUrl: `${extendedUrl}/version`,
    versionConfigUrl: `${extendedUrl}/plugin-settings/media-version`,
    statusUrl: `${extendedUrl}/status`,
    labelsConfigUrl: `${extendedUrl}/labels`,
    mediaPipelineStagesUrl: `${extendedUrl}/media-pipeline-stage`,
    mediaPipelineUrl: `${extendedUrl}/media-pipeline`,
    transcriptConfigUrl: `${extendedUrl}/plugin-settings/ai-transcript`,
    mediaPipelineLog: `${extendedUrl}/media-pipeline-log`,
    mediaPipelineDashboardWidgetUrl: `${extendedUrl}/media-pipeline-stage-assets/dashboard`,
    mediaQCUrl: `${extendedUrl}/media-qc`,
    advancedPropertiesConfigUrl: `${extendedUrl}/advanced-metadata`,
    getDataWithoutAuthUrl: `${extendedUrl}/serve-logo`,
    departmentsURL: `${extendedUrl}/department`,
    permittedDepartmentsURL: `${extendedUrl}/user-departments`,
    socialMediaProfilesUrl: `${extendedUrl}/plugin-settings/hype/social-media-profiles`,
    allLanguagesURL : `${extendedUrl}/languages`,
    languageURL:`${extendedUrl}/language`,
    markedForDeleteReportURL: `${extendedUrl}/marked-for-delete-report`,
    deletedPermanentlyReportURL: `${extendedUrl}/deleted-permanently-report`,
    assetAnnotationURL: `${extendedUrl}/assets/annotation`,
    assetKeywordSearchInFiltersURL: `${extendedUrl}/assets-keyword-search-in-filters`,
    assetsReportsURL: `${extendedUrl}/assets-report`,
    LDAPConfigURL: `${extendedUrl}/ldap-settings`,
    mediaPipelineStartupDataURL: `${extendedUrl}/media-pipeline-startup-data`,
    userPreferencesURL: `${extendedUrl}/user-preferences`,
    userGetVerificationCodeURL: `${extendedUrl}/user-preferences/verify-email`,
    userProfileEmailVerifyURL : `${extendedUrl}/verification`,
    userProfileVerifyEmailStatusURL : `${extendedUrl}/verification/mail-tokens`,
    allReportsList: `${extendedUrl}/settings/reports/types`,
    //------------PAM-----------------
    pamTemplatesURL:`${extendedUrl}/pam-templates`,
    PAMPipelineURL:`${extendedUrl}/pipeline`,
    stagesTasksURL:`${extendedUrl}/stage-tasks`,
    //--------------------------------
    //---------Quick Access Panel-----
    userWorkspaceURL:`${extendedUrl}/user-workspace`,
    configuredUserWorkspacePanelURL:`${extendedUrl}/user-workspace-panel-order`,
    //--------------------------------

    //----Buttons--------------
    buttonsURL:`${extendedUrl}/buttons`,
    configuredButtonsURL:`${extendedUrl}/buttons/configured-buttons`,
    componentButtonsURL:`${extendedUrl}/buttons/component-buttons`,
    buttonActionsURL:`${extendedUrl}/buttons/actions`,
    //-------------------------
    //-------------- New Archive report -----------
    newArchiveReportURL:`${extendedUrl}/reports/archive`,
    //---------- END of New Archive report -------------
    downloadPDFURL:`${extendedUrl}/fusion-pages/download-pdf`,

    //--------------alto----------------
    altoContainerStatusURL:`${extendedUrl}/location_info/alto`,
    //--------------END of alto----------------
    usersRecordsLimit: 10,
    acceptedStatusCodes: [200, 201, 206],
    rejectedStatusCodes: [400, 500, 401],
    defaultToastTime: 3000,
    maxToastsInPage: 20,
    toastTransition: "Vue-Toastification__bounce", //"Vue-Toastification__[bounce/fade/slideBlurred]"
    supportedToastType: ["success", "fail", "notify", "info"],
    binProtocolTypes: [
        {_id:"", label:""},
        {_id:"file",label:"file"},
        {_id:"ftp", label:"ftp"},
        {_id:"smb",label:"smb"},
        {_id:"aws", label:"AWS-S3-Cloud"}],
    maxChunkSize: 1 * 1024 * 1024,
    maxChunkSizeForCloud: 5 * 1024 * 1024,
    maxUploadThreads: 5,
    noImage: NoImg,
    folderImage: folderImg,
    damLogo: damLogo,
    favIcon: favIcon,
    uploadGif: uploadGif,
    loadingGif: loadingGif,
    projectBackground:projectBackground,
    markForDeleteIcon: markForDeleteIcon,
    catalogTreeStructureImg: catalogTreeStructureImg,
    noDataFoundImage: noDataFound,
    fusionLogoWithText:fusionLogoWithText,
    notificationAudio: notificationAudio,
    secondaryNotificationAudio: secondaryNotificationAudio,
    facebookLogo:facebookLogo,
    youtubeLogo:youtubeLogo,
    youtubeLogo1:youtubeLogo1,
    youtubeThumb:youtubeThumb,
    twitterLogo:twitterLogo,
    newImage:newImage,
    altoLogo:altoLogo,
    downloadingGif:downloadingGif,
    editProCutImage:editProCutIcon,
    loadingImage:loadingImage,
    AIImage:AIImage,
    MetadataSmartExtractImage:MetadataSmartExtractImage,
    jobStates: ["NEW", "SCHEDULED", "QUEUED", "INITIALIZING", "IN_PROGRESS", "VERIFYING", "COMPLETED", "ARCHIVED", "PAUSED", "NOT_RESPONDING", "ABORTED", "FAILED", "PENDING"],
    maxParallelUploads: 2,
    jobStatusUpdateNotification: "JOB_STATUS_UPDATE",
    retreiveSettingsNotification: "RETRIEVAL_SETTINGS_UPDATED",
    uploadSettingsNotification : "UPLOAD_SETTINGS_UPDATED",
    userUpdatedNotification : "USER_UPDATED",
    plugininstalledNotification : "PLUGIN_INSTALLED",
    pluginupgradedNotification : "PLUGIN_UPGRADED",
    pluginUninstalledNotification : "PLUGIN_UNINSTALLED",
    plugininstalledNotificationinspluginStore : "PLUGIN_INSTALLED",
    pluginUninstalledNotificationpluginStore : "PLUGIN_UNINSTALLED",
    rootCategory: "0",
    adminPrivilege: "SystemAdmin",
    loadEmpty:'0',
    loadWhenCatalog:'Catalog',
    loadWhenMimeTypes:'MimeType',
    loadWhenUserName:'User',
    loadWhenGroupName:'UserGroup',
    loadWhenScreenName:'Screen',
    loadWhenAdvancedExp:'AdvancedExpression',
    profileTags:'7',
    profileFields:'8',
    supportedDocumentPreviewList:['doc', 'docx', 'rtf', 'txt', 'pdf', 'xls', 'xlxs', 'xlsx', 'ppt', 'pptx', 'odt', 'html', "ods", "csv", "xml","py","js","json","md","log"], //need to remove once it is moved to backend
    supported3dModelPreviewList:['glb','stl','obj','fbx','collada','3ds','iges','step','vrml','x3d'], //need to remove once it is moved to backend
    chatToastTimeOut: 5000, //seconds
    WORKSPACE_CATALOG:'catalogs',
    WORKSPACE_BINS:'bins',
    WORKSPACE_PROJECTS:'projects',
    WORKSPACE_TICKETS:'tickets',
    WORKSPACE_TASKS:'tasks',
    WORKSPACE_ISSUES:'issues',
    FETCH_FILE_AS_OPTIONS:['Filename','Slugname']
}
